import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import BranchesPage from "@/pages/BranchesPage";
import ContactPage from "@/pages/ContactPage";
import MortgagedGoldPage from "@/pages/MortgagedGoldPage";
import SellGoldGurgaonPage from "@/pages/SellGoldGurgaonPage";
import SellSilverPage from "@/pages/SellSilverPage";
import GolfCourseRoadPage from "@/pages/GolfCourseRoadPage";
import GoldLoanVsSellPage from "@/pages/GoldLoanVsSellPage";
import BankMortgagedJewelleryPage from "@/pages/BankMortgagedJewelleryPage";
import GalleryPage from "@/pages/GalleryPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/sell-gold-gurgaon" element={<SellGoldGurgaonPage />} />
          <Route path="/sell-silver-gurgaon" element={<SellSilverPage />} />
          <Route
            path="/cash-for-gold-golf-course-road-gurgaon"
            element={<GolfCourseRoadPage />}
          />
          <Route
            path="/gold-loan-vs-selling-gold"
            element={<GoldLoanVsSellPage />}
          />
          <Route path="/mortgaged-gold" element={<MortgagedGoldPage />} />
          <Route
            path="/bank-mortgaged-jewellery"
            element={<BankMortgagedJewelleryPage />}
          />
          <Route path="/girvi-sona" element={<MortgagedGoldPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/branches" element={<BranchesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <FloatingActions />
      </BrowserRouter>
    </div>
  );
}

export default App;
